<template>

  <div class="">

    <!-- <div class="flex flex-row items-center justify-between bb bt b--moon-gray pa1 pa3-ns ma2">
      <h1 class="hymnal-name gray">{{ hymnal.name }}</h1>
      <img class="hymnal-cover" :src="img" :alt="hymnal.name + ' Hymnal Cover'">
    </div> -->

    <div v-if="hymnalName === 'wcg1974'"
      class="flex flex-row items-center justify-between bb bt b--moon-gray pa1 pa3-ns ma2">

      <h1 class="hymnal-name gray">WCG Hymnal (1974)</h1>

      <img class="hymnal-cover" src="@/assets/wcg1974hymnalcover.jpg" alt="WCG 1974 Hymnal Cover" />

    </div>

    <div v-if="hymnalName === 'wcg1993'"
      class="flex flex-row items-center justify-between bb bt b--moon-gray pa1 pa3-ns ma2">

      <h1 class="hymnal-name gray">WCG Hymnal (1993)</h1>

      <img class="hymnal-cover" src="@/assets/wcg1993hymnalcover.jpg" alt="WCG 1993 Hymnal Cover" />

    </div>

    <div v-if="hymnalName === 'ucg1997'"
      class="flex flex-row items-center justify-between bb bt b--moon-gray pa1 pa3-ns ma2">

      <h1 class="hymnal-name gray">UCG Hymnal (1997)</h1>

      <img class="hymnal-cover" src="@/assets/ucg1997hymnalcover.png" alt="UCG 1997 Hymnal Cover" />

    </div>

    <div v-if="hymnalName === 'ucg2007'"
      class="flex flex-row items-center justify-between bb bt b--moon-gray pa1 pa3-ns ma2">

      <h1 class="hymnal-name gray">UCG Hymnal (2007)</h1>

      <img class="hymnal-cover" src="@/assets/ucg2007hymnalcover.png" alt="UCG 2007 Hymnal Cover" />

    </div>

    <div v-if="hymnalName === 'lcg2005'"
      class="flex flex-row items-center justify-between bb bt b--moon-gray pa1 pa3-ns ma2">

      <h1 class="hymnal-name gray">LCG Hymnal (2005)</h1>

      <img class="hymnal-cover" src="@/assets/lcg2005hymnalcover.jpg" alt="LCG 2005 Hymnal Cover" />

    </div>

    <div v-if="hymnalName === 'cogwa2011'"
      class="flex flex-row items-center justify-between bb bt b--moon-gray pa1 pa3-ns ma2">

      <h1 class="hymnal-name gray">COGWA Hymnal (2011)</h1>

      <img class="hymnal-cover" src="@/assets/cogwa2011hymnalcover.jpg" alt="COGWA 2011 Hymnal Cover" />

    </div>

    <div v-if="hymnalName === 'pacific2018'"
      class="flex flex-row items-center justify-between bb bt b--moon-gray pa1 pa3-ns ma2">

      <h1 class="hymnal-name gray">Pacific Hymnal (2018)</h1>

      <img class="hymnal-cover" src="@/assets/pacific2018hymnalcover.jpg" alt="Pacific 2018 Hymnal Cover" />

    </div>

    <div v-if="hymnalName === 'tccog2010'"
      class="flex flex-row items-center justify-between bb bt b--moon-gray pa1 pa3-ns ma2">

      <h1 class="hymnal-name gray">Tri-Cities (2010)</h1>

      <img class="hymnal-cover" src="@/assets/tccoghymnal.jpg" alt="Tri-Cities Hymnal Cover" />

    </div>

  </div>

</template>

<script setup>
defineProps({
  hymnalName: {
    type: String,
    required: true
  },
  hymnal: {
    type: Object,
    required: false
  }
})
</script>

<style></style>
